/* wybór api pod wgranie w const typ

    1 - developerski                marcel-ebus-dev.top
    2 - produkcja                   ebus.marcel-bus-pl
    3 - testowy dla krzysia         marcel-ebus.topsa.com.pl

*/


const typ = 2;      // 1 -dev, 2 - prod, 3 - dla krzysia


export default class AppConfig {

    static APP_NAME() {
        return 'Marcel'
    }

    static APP_VER() {
        switch (typ) {
            case 1:
                return 'v2.26-dev-lukasz';
            case 2:
                return 'v2.28-prod';
            case 3:
                return 'v1.8-test'
        }
    }

    static APP_UPDATE() {

        let data = '2026-10-28 09:30'
        return data

    }

    static HOST_API() {
        switch (typ) {
            case 1:
                // return 'http://linuxdev.top:8084/api/'
                return 'http://centos7.top:9101/api/'
            case 2:
                return window.location.protocol + '//api-ebus.marcel-bus.pl/api/'
            case 3:
                return window.location.protocol + '//api-marcel-ebus.topsa.com.pl/api/'
        }

    }

    static HOST_CLIENT_API() {
        switch (typ) {
            case 1:
                // return 'http://linuxdev.top:8084/client/api/'
                return 'http://centos7.top:9101/client/api/'
            case 2:
                return window.location.protocol + '//api-site.marcel-bus.pl/client/api/'
            case 3:
                return window.location.protocol + '//api-marcel-site.topsa.com.pl/client/api/'
        }

    }
}



// WEBPACK FOOTER //
// ./src/AppConfig.js